/**
 * Announcement bar marquee.
 *
 * Only scrolls when the copy is genuinely wider than the bar. If it fits, the
 * bar stays centred and static — motion with no purpose is just motion, and
 * this sits above every page on the site.
 *
 * The track is filled with enough copies to cover the bar, then that whole set
 * is duplicated exactly once. Animating to translateX(-50%) therefore lands on
 * a pixel-identical position, which is what makes the loop seamless. Duration
 * is derived from width so the speed is constant regardless of copy length or
 * viewport.
 */
(function () {
  var SPEED_PX_PER_SEC = 144; // px per second

  var bar = document.querySelector('.tft-announcement');
  var track = bar && bar.querySelector('.tft-announcement-track');
  if (!track) return;

  var original = track.innerHTML;

  function layout() {
    track.classList.remove('is-scrolling');
    track.style.removeProperty('--marquee-duration');
    track.innerHTML = original;

    var oneWidth = track.scrollWidth;
    var barWidth = bar.clientWidth;
    if (!oneWidth || oneWidth <= barWidth) return; // fits: leave it still

    // Enough copies to cover the bar, then double the set so -50% is exact.
    var copies = Math.ceil(barWidth / oneWidth) + 1;
    var set = new Array(copies + 1).join(original);
    track.innerHTML = set + set;

    // Announce the message once, not once per copy.
    var items = track.querySelectorAll('.tft-announcement-text');
    for (var i = 1; i < items.length; i++) {
      items[i].setAttribute('aria-hidden', 'true');
    }

    // Add the class BEFORE measuring: .is-scrolling is what applies the
    // per-copy padding-right, so measuring first reads a track that is short
    // by one gap per copy and the animation ends up running fast.
    track.classList.add('is-scrolling');
    track.style.setProperty(
      '--marquee-duration',
      track.scrollWidth / 2 / SPEED_PX_PER_SEC + 's'
    );
  }

  layout();

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(layout, 150);
  });

  // Web fonts land after first paint and change the measured width, so redo
  // the maths once they are ready rather than locking in a wrong duration.
  // fonts.ready resolves before the reflow has actually applied, so measuring
  // in that microtask still reads the fallback-font width — hence the frame.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready
      .then(function () { requestAnimationFrame(layout); })
      .catch(function () {});
  }
})();
